import { Component, Input, OnInit } from '@angular/core';
import * as fromORing from '../../../store/fromORing.barrel'
import { Store } from '@ngrx/store';
import { ORing } from 'src/app/models';
import { map, Observable, of, tap } from 'rxjs';

@Component({
  selector: 'app-oring-options',
  templateUrl: './oring-options.component.html',
  styleUrls: ['./oring-options.component.scss']
})
export class ORingOptionsComponent implements OnInit {
  @Input() closurePartNumber: string = '';
  public filteredProducts$: Observable<ORing[]> = of([]);
  public showLoader$: Observable<boolean> = of(true);

  constructor(private store: Store<fromORing.State>) { }

  ngOnInit(): void {    
    this.store.dispatch(fromORing.updateORingFilter({
      obj: { closurePartNumber: this.closurePartNumber }
    }));

    this.filteredProducts$ = this.store.select(fromORing.selectORingsForClosure);

    
    this.showLoader$ = this.store.select(fromORing.selectHasLoader(fromORing.Loaders.loadORings));
  }

}
